<template>
  <WfRow
    v-if="!isRoot"
    :selectable="true"
    :expandable="true"
    :level="level"
    :status="status"
    :is-open="isOpen"
    @open="isOpen = $event"
    @check="handleCheck"
  >
    <template #title>
      <strong>{{ groupName }}</strong>
    </template>
    <template #content v-if="!!group.variables">
      <WfVariable
        v-for="variable in group.variables"
        :key="variable.id"
        :variable="variable"
        :level="level + 1"
      />
    </template>
  </WfRow>
  <WfVariable
    v-else
    v-for="variable in group.variables"
    :key="variable.id"
    :variable="variable"
    :level="level"
  />
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import WfVariable from './WfVariable.vue';
import WfRow from './row/WfRow.vue';

const props = defineProps({
  group: {
    type: Object,
    required: true,
  },
  level: {
    type: Number,
    default: 0,
  },
});

const store = useStore();

const status = computed(() => {
  return store.getters['variable/getGroupStatus'](props.group);
});

const isOpen = ref(false);

const isRoot = computed(() => props.group.name === 'Root');

const groupName = computed(() => {
  return props.group.name.split('/').join(' / ');
});

const handleCheck = () => {
  store.dispatch('variable/toggleGroup', props.group);
};
</script>
